module.exports = __webpack_public_path__ + "static/media/profile-michelle-lim.00d20e95.png";